import styles from './OpinionPage.module.scss';

import { Loader } from '@/components';
import { useNavigation } from '@/hooks/useNavigation';
import { Opinions } from '@/modules/opinions';
import { useOpinions } from '@/modules/polls/components/PollsOpinion/OpinionPollsProvider';

import { observer } from 'mobx-react-lite';
import { useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';

const OpinionPageContent = observer(() => {
  const { data, fetchNextPage, isLoading } = useOpinions();
  const { params } = useNavigation();
  const portalTarget = document.getElementById('root')!;

  useLayoutEffect(() => {
    const root = document.getElementById('root');
    if (root) root.classList.add('transparentPage');
    return () => {
      if (root) root.classList.remove('transparentPage');
    };
  }, []);

  const opinionId = params.id;

  if (isLoading) return <Loader isHeaderVisible />;
  if (!opinionId || !data) return null;

  const opinionsList = data.pages.flat();

  const activeSlideIndex = Math.max(
    opinionsList.findIndex(({ _id }: { _id: string }) => _id === opinionId),
    0,
  );

  return createPortal(
    <div className={styles.opinionWrapperFullscreen}>
      <Opinions
        fetchNextPage={fetchNextPage}
        data={opinionsList}
        activeSlideIndex={activeSlideIndex}
        showAds={true}
      />
    </div>,
    portalTarget,
  );
});

export const OpinionPage = observer(() => {
  const { id: opinionId } = useParams();
  if (!opinionId) return null;

  return <OpinionPageContent />;
});
